export default "__VITE_ASSET__CiGiG68K__"